(() => {
  const capture = document.querySelector('[data-rm-capture]');
  if (!capture) return;

  const dialog = capture.querySelector('.rm-capture__dialog');
  const heading = capture.querySelector('#rm-capture-title');
  const closeButtons = capture.querySelectorAll('[data-rm-capture-close]');
  const success = capture.hasAttribute('data-rm-capture-success');
  const storageKey = 'roadsideWelcomeCapture';
  const sessionKey = storageKey + 'Dismissed';
  const dismissForDays = 14;
  let previousFocus = null;
  let dismissed = false;
  let opened = false;
  let timer;
  let background = [];
  capture.querySelectorAll('[autofocus]').forEach((element) => element.removeAttribute('autofocus'));

  const remember = (value) => {
    try {
      localStorage.setItem(storageKey, JSON.stringify({ value, time: Date.now() }));
    } catch (error) {}
  };

  const shouldShow = () => {
    if (dismissed || opened) return false;
    try {
      if (sessionStorage.getItem(sessionKey)) return false;
    } catch (error) {}
    if (success) return true;
    try {
      const stored = JSON.parse(localStorage.getItem(storageKey));
      if (!stored) return true;
      if (stored.value === 'subscribed') return false;
      return Date.now() - stored.time > dismissForDays * 24 * 60 * 60 * 1000;
    } catch (error) {
      return true;
    }
  };

  const stopTriggers = () => {
    window.clearTimeout(timer);
    window.removeEventListener('scroll', onScroll);
  };

  const open = () => {
    if (!shouldShow()) return;
    opened = true;
    stopTriggers();
    previousFocus = document.activeElement;
    capture.hidden = false;
    document.body.classList.add('rm-capture-open');
    background = [...document.querySelectorAll('#MainContent, .rm-site-header, .rm-site-footer')]
      .filter((element) => !element.contains(capture))
      .map((element) => ({ element, wasInert: element.hasAttribute('inert') }));
    background.forEach(({ element }) => element.setAttribute('inert', ''));
    heading.focus({ preventScroll: true });
  };

  const close = () => {
    if (capture.hidden) return;
    dismissed = true;
    stopTriggers();
    capture.hidden = true;
    document.body.classList.remove('rm-capture-open');
    background.forEach(({ element, wasInert }) => {
      if (!wasInert) element.removeAttribute('inert');
    });
    background = [];
    try { sessionStorage.setItem(sessionKey, 'true'); } catch (error) {}
    if (!success) remember('dismissed');
    if (previousFocus && previousFocus.isConnected && typeof previousFocus.focus === 'function') {
      previousFocus.focus({ preventScroll: true });
    }
  };

  function onScroll() {
    const scrollable = document.documentElement.scrollHeight - window.innerHeight;
    if (scrollable > 0 && window.scrollY / scrollable >= 0.4) open();
  }

  closeButtons.forEach((button) => button.addEventListener('click', close));
  document.addEventListener('keydown', (event) => {
    if (capture.hidden) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      close();
      return;
    }
    if (event.key !== 'Tab') return;
    const focusable = [...dialog.querySelectorAll('button, input:not([type="hidden"]), select, textarea, a[href], iframe, [tabindex]:not([tabindex="-1"])')]
      .filter((element) => !element.disabled && element.tabIndex >= 0 && element.offsetParent !== null);
    if (!focusable.length) {
      event.preventDefault();
      heading.focus();
      return;
    }
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && (document.activeElement === first || !focusable.includes(document.activeElement))) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && (document.activeElement === last || !dialog.contains(document.activeElement))) {
      event.preventDefault();
      first.focus();
    }
  });

  if (success) remember('subscribed');
  if (shouldShow()) {
    timer = window.setTimeout(open, 8000);
    window.addEventListener('scroll', onScroll, { passive: true });
  }
})();
